import browserSvg from '@/assets/icons/browser.svg';

interface BrowserProps {
  className?: string;
}

export default function Browser({ className = '' }: BrowserProps) {
  return (
    <img
      src={browserSvg}
      alt="Browser"
      className={className}
    />
  );
}
